import { render, staticRenderFns } from "./HistoricHoursClaim.vue?vue&type=template&id=6f5b79ae"
import script from "./HistoricHoursClaim.vue?vue&type=script&lang=ts"
export * from "./HistoricHoursClaim.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports